/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from "react";
import { pdfjs } from "react-pdf";
import { saveAs } from "file-saver";
import { useDataLoader } from "react-remote-data-hooks";
import api from "../../../../api";
import { ContainerLoader } from "../../../../components/loader";
import { generateUrl, MediaFile } from "../../../../core";
import { PreviewableFileFormats } from "../../../../utils/fileFormats";
import NoPreview from "../../../../assets/images/alertTriangle.svg";
export interface CustomProps {
  pdfUrl: string;
  file?: MediaFile;
}

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFView: React.FunctionComponent<CustomProps> = (props) => {
  const fileType = props.file?.contentType?.split("/").pop() || "";
  const pattern = `\\b(?:${PreviewableFileFormats.join("|")})\\b`;
  const regex = new RegExp(pattern);
  const previewableFile = regex.test(fileType?.trim());

  const { data: signedUrl, reload, loaded } = useDataLoader<string>(
    async (mediaFile?: MediaFile) =>
      mediaFile ? api.upload.getSignedMediaFileUrlNoCash(mediaFile) : undefined,
    []
  );
  React.useEffect(() => {
    if (!!fileType && !!props.file) {
      reload(props.file);
    }
  }, [props.file, fileType]);

  const downloadFile = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (signedUrl) {
      // const link = document.createElement("a");
      // link.href = signedUrl;
      // link.setAttribute("download", props.file?.originalname || "unknown.file");
      // link.style.display = "none";
      // if (!previewableFile) link.target = "_blank";
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      saveAs(signedUrl, props.file?.originalname || "unknown.file");
    }
  };

  if (!signedUrl) {
    return <ContainerLoader height={500} />;
  }

  return (
    <div className="p-4">
      <div className="d-flex flex-column ">
        <button
          type="button"
          onClick={downloadFile}
          disabled={!signedUrl}
          className="btn btn-primary  font-normal font-weight-bold align-self-end  mb-1"
        >
          Download
        </button>
        {previewableFile && signedUrl ? (
          <>
            {props?.file?.mimetype?.split("/")?.[0] === "image" ? (
              <img src={signedUrl} alt={props.file?.originalname} />
            ) : (
              <iframe
                src={!!loaded && !!signedUrl ? generateUrl(signedUrl, fileType)  : undefined}
                width="100%"
                height="1000"
                title="title"
                onLoad={(e) => e.preventDefault()}
                />
            )}
          </>
        ) : (
          <div className="d-flex flex-column align-items-center ">
            <img src={NoPreview} alt="Download to Preview" style={{ width: "15%" }} />
            <p className="font-xxs font-weight-bold">Download to Preview</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PDFView;
